import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "isNumber" })
export class IsNumberPipe implements PipeTransform {
    transform(value: any): any {
        if (value === null) {
            return false;
        }
        return (0 + value) === value;
    }
}
